import React from "react";
import styles from "./DashPage3.module.scss";
export default function DashPage3() {
  return (
    <div className={styles.mainwrapper}>
      <div>
        <p>Hellooooooooooooooooooooooooo</p>
      </div>
      <div>
        <p>Welcomeeeeeeeeeeeeeeeeeeeeee</p>
      </div>
    </div>
  );
}
